export default __webpack_public_path__ + "static/media/del-icn.857ac683.svg";